import { styled } from "@linaria/react";

import Beacon, { BeaconVariant } from "@gx/dls/beacons/Beacon";
import Text, { TextSize, TextVariant, TextWeight } from "@gx/dls/text/Text";
import { withTheme } from "@gx/dls/theme";
import type { PropsWithTheme } from "@gx/dls/theme/types";

const StatusChipWrapper = withTheme(styled.div<PropsWithTheme<{ $bottom: number }>>`
  position: absolute;
  bottom: ${({ $bottom }) => $bottom}px;
  left: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background-color: ${({ theme }) => theme.color.background.base};
  border: 0.5px solid ${({ theme }) => theme.color.border.primary};
  border-radius: 5px;
  z-index: 10;
`);

export type BrowserbaseStatusChipVariant = "live" | "recorded";

interface BrowserbaseStatusChipProps {
  variant: BrowserbaseStatusChipVariant;
  bottom?: number;
}

export function BrowserbaseStatusChip({ variant, bottom = 12 }: BrowserbaseStatusChipProps) {
  const isLive = variant === "live";

  return (
    <StatusChipWrapper $bottom={bottom}>
      <Beacon variant={isLive ? BeaconVariant.ERROR : BeaconVariant.BLUE} isPulse={isLive} />
      <Text
        size={TextSize.CAPTION}
        variant={isLive ? TextVariant.ERROR : TextVariant.BLUE}
        weight={TextWeight.MEDIUM}
      >
        {isLive ? "LIVE" : "RECORDED"}
      </Text>
    </StatusChipWrapper>
  );
}
